import axios from "axios";
import config from "../config";
import validator from "./validator/dataValidator";

export default {
  getDocsTabs: (getDocsList) => {
    return new Promise((resolve) => {
      axios.get(config.getTabsEndpoint + "?getDocsList=" + getDocsList).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  getDocsInfoAndFields: (getDocsList) => {
    return new Promise((resolve) => {
      axios.get(config.getDocsInfoAndFieldsEndpoint).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  getAllFields: () => {
    return new Promise((resolve) => {
      axios.get(config.getFieldsAdminEndpoint).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  getFields: (docsIdsList, dealId, isLawyerView, clientEmail) => {
    return new Promise((resolve) => {
      var getEndpoint;
      var jsonData = { dealId };
      if (isLawyerView) {
        getEndpoint = config.getFieldsWithDataEndpoint;
        jsonData["docsIdsList"] = docsIdsList;
      } else {
        getEndpoint = config.getPublicFieldsEndpoint;
        jsonData["clientEmail"] = clientEmail;
      }

      axios.post(getEndpoint, jsonData).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  saveFields: (dealId, fields, sellersAmount, buyersAmount, thirdAmount, clientEmail, isLawyerView) => {
    return new Promise((resolve) => {
      if (isLawyerView) {
        axios.post(config.saveFieldsEndpoint, { fields, dealId, sellersAmount, buyersAmount, thirdAmount }).then((serverRes) => {
          if (serverRes.data) return resolve(serverRes.data);
          resolve({ err: "Problem with the request" });
        });
      } else {
        // client fills
        axios
          .post(config.clientFillsDataEndpoint, {
            fields,
            clientEmail,
            dealId,
            sellersAmount,
            buyersAmount,
            thirdAmount
          })
          .then((serverRes) => {
            if (serverRes.data) return resolve(serverRes.data);
            resolve({ err: "Problem with the request" });
          });
      }
    });
  },

  generateDocs: (dealId, docIdsList, fields, isSendByEmail, email, sellersAmount, buyersAmount, thirdAmount) => {
    return new Promise((resolve) => {
      if (isSendByEmail) {
        validator.propertiesValidator({ email }).then(
          (ans) => {
            var validatedData = ans["validatedData"];
            axios
              .post(config.generateDocsEndpoint, {
                dealId,
                docIdsList,
                fields,
                isSendByEmail,
                insertedEmailForDocs: validatedData.email,
                sellersAmount,
                buyersAmount,
                thirdAmount
              })
              .then((serverRes) => {
                if (serverRes.data) return resolve(serverRes.data);
                resolve({ err: "Problem with the request" });
              });
          },
          (err) => {
            return resolve({ badEmailFormat: err.email });
          }
        );
      } else {
        // for downloading files
        axios({
          url: config.generateDocsEndpoint,
          method: "post",
          responseType: "blob",
          data: {
            docIdsList,
            dealId,
            fields,
            sellersAmount,
            buyersAmount,
            thirdAmount
          }
        }).then((response) => {
          if (!response || !response.data) return resolve({ err: "Problem with request" });
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "קבצים.zip");
          document.body.appendChild(link);
          link.click();
          link.remove();
          return resolve({ success: true });
        });
      }
    });
  }
};
